import { getRegisterFunction } from '../../utils/register.js';
import { OneUxSwitchElement } from './OneUxSwitchElement.js';
export const register = getRegisterFunction(OneUxSwitchElement);
declare global {
  interface HTMLElementTagNameMap {
    'one-ux-switch': OneUxSwitchElement;
    "switch-7c56f581ecc348cdcc81849ce2c2c313": OneUxSwitchElement;
  }
}